import React, { useEffect, useRef, useState } from 'react'
import Layout from '../components/Layout'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { api } from '../helper/api';
import { useToasts } from 'react-toast-notifications';
import { IPFStoURL, formatPrice, trimAddress } from '../helper/functions';
import { DEFAULT_IMAGES } from '../helper/constant';

export default function CollectionInfo() {
    const [nftData, setNftData] = useState([]);
    const [collectionData, setCollectionData] = useState([]);
    const { nftaddress } = useParams();
    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalPages: 1,
        totalRecords: 0,
        loading: true
    })

    const navigate = useNavigate();
    const { addToast } = useToasts();
    const count = useRef(0);
    

    useEffect(() => {
        async function fetch() {
            let collectionData = await api.get('collection/get', {
                params: {
                    nft_address: nftaddress,

                }
            })

            if (collectionData.data && collectionData.data.error === 'OK' && collectionData.data.data.length > 0) {
                setCollectionData(collectionData.data.data[0]);
            }
            else {
                //redirect
                addToast("No collection found, please check and try again", { appearance: 'error' });
                navigate('/');
            }
        }
        if (nftaddress && count.current === 0) {
            count.current = 1;
            fetch();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nftaddress]);

    useEffect(() => {
        async function fetch() {
            let collectionNFTs = await api.get('nft', {
                params: {
                    nft_address: collectionData.nft_address,
                    page: pagination.currentPage
                }
            })

            if (collectionNFTs && collectionNFTs.data && collectionNFTs.data.data) {
                setNftData(collectionNFTs.data.data)
                setPagination(prev => ({
                    ...prev,
                    totalPages: collectionNFTs.data.totalPages,
                    totalRecords: collectionNFTs.data.totalRecord,
                    loading: false
                }));
            }
        }

        if (collectionData && collectionData.nft_address) {
            fetch();
        }
    }, [collectionData, pagination.currentPage]);



    const handlePageChange = (page) => {
        let newPage;

        if (page === 'prev' && parseInt(pagination.currentPage) - 1 >= 1) {
            newPage = Math.max(1, parseInt(pagination.currentPage) - 1);
        } else if (page === 'next' && parseInt(pagination.currentPage) < parseInt(pagination.totalPages)) {
            newPage = Math.min(parseInt(pagination.totalPages), parseInt(pagination.currentPage) + 1);
        } else {
            // If it's not 'prev' or 'next', set the newPage to the selected page
            newPage = parseInt(page);
        }

        // Check if the current page is different from the new page
        if (newPage !== parseInt(pagination.currentPage)) {
            setPagination((prevPagination) => ({
                ...prevPagination,
                currentPage: newPage,
                loading: true
            }));
        }
    };

    return (
        <Layout>
            <div class="no-bottom no-top" id="content">

                <section
                    id="profile_banner"
                    aria-label="section"
                    className="text-light"
                    style={{
                        backgroundImage: `url('${IPFStoURL(collectionData.banner)}')`,
                        backgroundPosition: 'center',

                    }}
                ></section>



                <div aria-label="section">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="align-items-center d_profile de-flex">
                                    <div class="de-flex-col">
                                        <div class="profile_avatar">
                                            <img src={IPFStoURL(collectionData.profile)} alt="" />
                                            <i class="fa fa-check"></i>
                                            <div class="profile_name">
                                                <h4>
                                                    {collectionData.name ? collectionData.name : ''}{" "}({collectionData?.symbol})
                                                    <span class="profile_username">{collectionData && collectionData.nft_address ? trimAddress(collectionData?.nft_address) : ''}</span>
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="profile_follow text-center">
                                        <h5>Total Supply</h5>
                                        <p>{collectionData && collectionData.totalSupply ? collectionData.totalSupply : '0'}{" "}{collectionData.symbol}</p>
                                    </div>
                                    <div class="profile_follow text-center">
                                        <h5>Total volume</h5>
                                        <p>{collectionData && collectionData.volume ? formatPrice(collectionData.volume / Math.pow(10, 18)) : '0'}{" "}BST</p>
                                    </div>
                                    <div class="profile_follow text-center">
                                        <h5>Floor price</h5>
                                        <p>{collectionData && collectionData.floor_price ? formatPrice(collectionData.floor_price / Math.pow(10, 18)) : '0'}{" "} BST</p>
                                    </div>


                                </div>
                            </div>



                            <div class="col-md-12">
                                <div class="de_tab tab_simple">
                                    <div class="de_tab_content">
                                        <div class="row">
                                            {pagination.loading ? (
                                                <div class="d-flex justify-content-center align-items-center vh-100">
                                                    <div class="spinner-border" role="status" id="loading">
                                                        <span class="visually-hidden">Loading...</span>
                                                    </div>
                                                </div>
                                            ) : (
                                                <>
                                                    {nftData && nftData.map((items, key) => {
                                                        let metadata = items.metaData ? JSON.parse(items.metaData) : {};
                                                        return (
                                                            <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12" key={key}>
                                                                <div class="nft__item style-2">

                                                                    <div class="nft__item_wrap">
                                                                        <Link to={`/${nftaddress}/${items.tokenId}`}>
                                                                            <img src={metadata && metadata.image ? IPFStoURL(metadata.image) : IPFStoURL(DEFAULT_IMAGES.profile.profile)} class="lazy nft__item_preview" alt="nft" />
                                                                        </Link>
                                                                    </div>
                                                                    <div className=''>


                                                                        <div class="d-flex align-items-center user-profile">
                                                                            <div class="image mx-2">
                                                                                <img src={items.user_profile ? IPFStoURL(items.user_profile) : IPFStoURL(DEFAULT_IMAGES.profile.profile)} class="rounded" width="24px" height="24px" alt='profile' />
                                                                            </div>
                                                                            <div class="ml-3 w-100">
                                                                                <h4 class="mb-0 mt-0">{items.username ? items.username : trimAddress(items.owner)}</h4>
                                                                                <span>{items.owner ? trimAddress(items.owner) : '- -'}</span>
                                                                            </div>
                                                                        </div>



                                                                    </div>
                                                                    <div class="nft__item_info p-2">
                                                                        <div className='d-flex justify-content-between'>
                                                                            <Link to={`/${items.nft_address}/${items.tokenId}`}>
                                                                                <h4>{metadata.name ? metadata.name : `${items.col_name}`} {metadata.name  && metadata.name.includes('#') ? '' : `#${items.tokenId}`}</h4>
                                                                            </Link>
                                                                            <span>{items.balance}X</span>
                                                                        </div>
                                                                        <div className='d-flex justify-content-between '>
                                                                            <div class="nft__item_price">
                                                                                <span>{items.nftHighestBid > 0 ? formatPrice(items.nftHighestBid / Math.pow(10, 18)) : items.order_price > 0 ? formatPrice(items.order_price / Math.pow(10, 18)) : ' - - '} BST</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })}
                                                    {nftData && nftData.length > 0 &&
                                                        <div className='col-12 d-flex justify-content-center'>
                                                            <nav aria-label="Page navigation example">
                                                                <ul className="pagination pagination">
                                                                    <li>
                                                                        <button

                                                                            disabled={parseInt(pagination.currentPage) === 1 || parseInt(pagination.currentPage) === 0} // Disable if on the first page
                                                                            onClick={() => handlePageChange('prev')}
                                                                        >
                                                                            Previous
                                                                        </button>
                                                                    </li>
                                                                    {Array.from({ length: pagination.totalPages }, (_, index) => (
                                                                        <li key={index}>
                                                                            <button
                                                                                className={`${pagination.currentPage === index + 1
                                                                                    ? 'active'
                                                                                    : ''
                                                                                    }`}
                                                                                onClick={() => handlePageChange(index + 1)}
                                                                            >
                                                                                {index + 1}
                                                                            </button>
                                                                        </li>
                                                                    ))}
                                                                    <li>
                                                                        <button
                                                                            disabled={parseInt(pagination.currentPage) === parseInt(pagination.totalPages)} // Disable if on the last page
                                                                            onClick={() => handlePageChange('next')}
                                                                        >
                                                                            Next
                                                                        </button>
                                                                    </li>
                                                                </ul>
                                                            </nav>
                                                        </div>
                                                    }
                                                </>
                                            )}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </Layout>
    )
}
